import React from "react";
import styled from "styled-components";
import { formatarPercentual } from "../../util/pixPrice";

// Selo "10% OFF no Pix" da vitrine (P-113). `ate` mostra "até 10% OFF" quando a loja do contexto ainda não é
// conhecida; `semRotulo` esconde o "no Pix" (quando o texto já vem ao lado).
const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

const Badge = styled.span`
  background-color: ${(props) => props.theme.colors.success};
  color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  padding: 2px 6px;
  font-size: ${(props) => (props.$small ? "11px" : "13px")};
  font-weight: 700;
  line-height: 1.3;
`;

const Label = styled.span`
  color: ${(props) => props.theme.colors.success};
  font-size: ${(props) => (props.$small ? "12px" : "14px")};
  font-weight: 600;
`;

export default function PixDiscountBadge({ perc, ate = false, small = false, semRotulo = false }) {
  if (!(Number(perc) > 0)) return null;

  return (
    <Wrap>
      <Badge $small={small}>
        {ate ? "até " : ""}
        {formatarPercentual(perc)}% OFF
      </Badge>
      {!semRotulo && <Label $small={small}>no Pix</Label>}
    </Wrap>
  );
}
